import React from 'react'
import MaterialSymbol from '../material-symbol'

const WbTwilight = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="wb_twilight" {...props} />
))

WbTwilight.displayName = 'WbTwilight'

export default WbTwilight
